module.exports = __webpack_public_path__ + "static/media/ic-nutricao.0697b7a6.svg";